import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: 150px;
  width: 100%;
  background: white;
  border-radius: 8px; 
  box-shadow: 1px 1px 6px #afadad;

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #131f28;
    padding: 5px 10px;
    border-radius: 8px;

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 15px;

      .image-container{
        height: 50px;
        width: 50px;
        background: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .image {
          height: 45px;
          width: 45px;
          border-radius: 50%;
        }
      }

      .name{
        font-size: 16px;
        color: white;
      }
    }
  }

  .body {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 10px;
    margin-top: 10px;
    gap: 15px;

    .content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;

      .text {
        font-size: 14px;
      }
    }

  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 10px;

    .login-button {
      background: #131f28;
      color: white;
      font-size: 16px;
      font-weight: 600;
      border: none;
      padding: 5px;
      width: 100px;
      border-radius: 5px;
    }
  }
`;
